import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import IdentifyUser from "./identifyUser";
import SignupUser from "./signupUser";
import RegisterUser from "./registerUser";
import VerifyUser from "./verifyUser";
import UseStyle from "../../../css/styles";
import { useEffect, useState } from "react";
import { Patient } from "../../../store";
import { CheckLoginExistance, VerifyPatient } from "../../../api";
import { Dialog, DialogContent, CircularProgress } from "@mui/material";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle Registration
// FB  7111   07/25/2023  DK  Password strength meter and green tick feature
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  8117   02/23/2024  DK  Avoid calling EMR API directly from Portal

const theme = createTheme({
  palette: {
    primary: {
      main: "#083A4D",
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});

export default function Signup() {
  var intialState: Patient = {} as Patient;
  intialState.PatientDOB = null as unknown as Date;
  var patientdata = sessionStorage.getItem("patientDemographics");
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    "Locate patient records",
    "Verification code",
    "Secure sign up",
    "Create an Account",
  ];
  const [patientDemographics, setPatientDemographics] =
    useState<Patient>(intialState);
  const [errors, setErrors] = useState({});
  const [signupErrors, setSignupErrors] = useState({});
  const [isUserVerified, setIsUserVerified] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  var JSAlert = require("js-alert");
  const styles = UseStyle();

  function ValidateForm() {
    if (
      patientDemographics.PatientFirstName == undefined ||
      patientDemographics.PatientFirstName === ""
    ) {
      setErrors((errors) => ({ ...errors, PatientFirstName: true }));
      return false;
    }
    if (
      patientDemographics.PatientLastName == undefined ||
      patientDemographics.PatientLastName === ""
    ) {
      setErrors((errors) => ({ ...errors, PatientLastName: true }));
      return false;
    }
    if (
      patientDemographics.PatientDOB == undefined ||
      patientDemographics.PatientDOB.toString() == ""
    ) {
      setErrors((errors) => ({ ...errors, PatientDOB: true }));
      return false;
    }
    if (
      patientDemographics.PatientGender == undefined ||
      patientDemographics.PatientGender === ""
    ) {
      setErrors((errors) => ({ ...errors, PatientGender: true }));
      return false;
    }
    // else if (patientDemographics.PatientGender === "3") {
    //     if (patientDemographics.PatientGender2 == undefined || patientDemographics.PatientGender2 === "") {
    //         setErrors((errors) => ({ ...errors, "PatientGender2": true }));
    //         return false;
    //     }
    // }
    if (
      patientDemographics.PatientZIP == undefined ||
      patientDemographics.PatientZIP === ""
    ) {
      setErrors((errors) => ({ ...errors, PatientZIP: true }));
      return false;
    }
    return true;
  }

  function ValidateSignupForm() {
    // FB 7111
    var regex = RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\\s])(?=.{8,})");
    if (
      patientDemographics.Login == undefined ||
      patientDemographics.Login === ""
    ) {
      setSignupErrors((signupErrors) => ({ ...signupErrors, Login: true }));
      return false;
    }
    if (
      patientDemographics.PatientPassword == undefined ||
      patientDemographics.PatientPassword === ""
    ) {
      setSignupErrors((signupErrors) => ({
        ...signupErrors,
        PatientPassword: true,
      }));
      return false;
    } else if (
      patientDemographics.PatientPassword2 == undefined ||
      patientDemographics.PatientPassword2 === ""
    ) {
      setSignupErrors((signupErrors) => ({
        ...signupErrors,
        PatientPassword2: true,
      }));
      return false;
    } else {
      if (!patientDemographics.PatientPassword.match(regex)) {
        JSAlert.alert(
          "Password doesn't match the criteria",
          null,
          JSAlert.Icons.Failed
        );
        setSignupErrors((signupErrors) => ({
          ...signupErrors,
          PatientPassword: true,
          PatientPassword2: true,
        }));
        return false;
      }
      if (
        !(
          patientDemographics.PatientPassword ===
          patientDemographics.PatientPassword2
        )
      ) {
        JSAlert.alert(
          "Entered passwords doesn't match",
          null,
          JSAlert.Icons.Failed
        );
        setSignupErrors((signupErrors) => ({
          ...signupErrors,
          PatientPassword: true,
          PatientPassword2: true,
        }));
        return false;
      }
    }
    return true;
  }

  const handleNext = async (e: any) => {
    e.preventDefault();
    if (activeStep === 0) {
      if (ValidateForm()) {
        let result = await VerifyPatient(patientDemographics);
        if (result.length > 1) {
          JSAlert.alert(
            "Error in creating account! Please contact Office",
            null,
            JSAlert.Icons.Failed
          ).then(function () {
            sessionStorage.removeItem("patientDemographics");
            window.location.reload();
          });
        } else {
          if (result.length > 0) {
            //FB 8117 Start
            if (
              result[0].patienT_MRA_ID == null ||
              result[0].patienT_MRA_ID == ""
            ) {
              setPatientDemographics({
                ...patientDemographics,
                PatientCellPhone: result[0].patienT_CELL_PHONE,
                PatientEmail: result[0].patienT_EMAIL,
                EMRID: result[0].patienT_N,
              });
              //FB 8117 End
              setActiveStep(activeStep + 1);
            } else {
              JSAlert.alert(
                "Account already exists. Please try login",
                null,
                JSAlert.Icons.Failed
              ).then(function () {
                sessionStorage.removeItem("patientDemographics");
                window.location.reload();
              });
            }
          } else {
            JSAlert.alert(
              "Sorry! We couldn't find your record. Please contact office",
              null,
              JSAlert.Icons.Failed
            ).then(function () {
              sessionStorage.removeItem("patientDemographics");
              window.location.reload();
            });
          }
        }
      }
    } else if (activeStep === 2) {
      if (ValidateSignupForm()) {
        setShowSpinner(true);
        const response = await CheckLoginExistance(patientDemographics);
        setShowSpinner(false);
        if (response != undefined) {
          if (response.alertType == "Success") {
            JSAlert.alert(response.message, null, JSAlert.Icons.Success).then(
              function () {
                setActiveStep(activeStep + 1);
              }
            );
          } else {
            JSAlert.alert(response.message, null, JSAlert.Icons.Failed);
          }
        }
      }
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleInputChange = (e: any) => {
    if (!isNaN(Date.parse(e))) {
      setErrors({ PatientDOB: false });
      setPatientDemographics({
        ...patientDemographics,
        PatientDOB: e,
      });
    } else {
      setErrors({ [e.target.name]: false });
      setPatientDemographics({
        ...patientDemographics,
        [e.target.name]: e.target.value,
      });
    }
  };

  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End

  useEffect(() => {
    sessionStorage.setItem(
      "patientDemographics",
      JSON.stringify(patientDemographics)
    );
  }, [patientDemographics]);

  useEffect(() => {
    if (isUserVerified) {
      setActiveStep(activeStep + 1);
    }
  }, [isUserVerified]);

  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return (
          <IdentifyUser
            errors={errors}
            handleInputChange={handleInputChange}
            patient={patientDemographics}
          />
        );
      case 1:
        return (
          <VerifyUser
            patient={patientDemographics}
            setIsUserVerified={setIsUserVerified}
          />
        );
      case 2:
        return (
          <SignupUser
            errors={signupErrors}
            handleInputChange={handleInputChange}
            patient={patientDemographics}
            setTermsAccepted={setTermsAccepted}
          />
        );
      case 3:
        return (
          <RegisterUser
            handleInputChange={handleInputChange}
            patient={patientDemographics}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={handleNext}>
        <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
          >
            <Typography
              component="h1"
              variant="h5"
              align={window.innerWidth < 350 ? "center" : "left"}
            >
              <strong>Create your {HeaderText} account</strong>{/* FB 7469 */}
            </Typography>
            <Stepper
              activeStep={activeStep}
              sx={{ pt: 3, pb: 5 }}
              orientation={window.innerWidth < 768 ? "vertical" : "horizontal"}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <React.Fragment>
                  <Typography variant="h5" gutterBottom>
                    Thank you for your order.
                  </Typography>
                  <Typography variant="subtitle1">
                    Your order number is #2001539. We have emailed your order
                    confirmation, and will send you an update when your order has
                    shipped.
                  </Typography>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {getStepContent(activeStep)}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {activeStep == 1 && (
                      <Button
                        variant="contained"
                        className={styles.navigationButton}
                        onClick={handleBack}
                        sx={{ mt: 3, ml: 1 }}
                      >
                        Back
                      </Button>
                    )}
                    <Button
                      type="submit"
                      variant="contained"
                      //onClick={handleNext}
                      className={
                        activeStep == 2 && !termsAccepted
                          ? styles.disabledButton
                          : styles.navigationButton
                      }
                      sx={{ mt: 3, ml: 1 }}
                      disabled={activeStep == 2 && !termsAccepted ? true : false}
                      style={{
                        display:
                          activeStep === steps.length - 1
                            ? "none"
                            : activeStep == 1 && !isUserVerified
                              ? "none"
                              : activeStep == 2 && !termsAccepted
                                ? "disabled"
                                : "block",
                      }}
                    >
                      Continue
                    </Button>
                  </Box>
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>

          <ThemeProvider theme={theme}>
            <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
              <DialogContent
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress style={{ color: "#083A4D" }} />
              </DialogContent>
            </Dialog>
          </ThemeProvider>
        </Container>
      </form>
    </ThemeProvider>
  );
}
